//银行管理api
import {ServerPriceApi} from '@/group-cloud/network/ServerBizApi';

//转账状态
export const Bank_Transfer_Status_Options = [
    {id: 2, label: '未完成充值'},
    {id: 1, label: '已完成充值'}
];

export class BankApi {

    constructor() {
    }
    protected static groupUrl = '/data-dist/api/money/center';
    
    //查询银行列表信息
    public static async getBankList(data){
        let uri = this.groupUrl + '/cardInfo';
        return await ServerPriceApi.sendNoBase(uri, data);
    }
    
    //保存银行信息
    public static async saveBankInfo(data){
        let uri = this.groupUrl + '/modifyBankCard';
        return await ServerPriceApi.sendNoBase(uri, data);
    }

    //删除银行信息
    public static async deleteBankInfo(data){
        let uri = this.groupUrl + '/deleteCard';
        return await ServerPriceApi.getNoBase(uri, data);
    }
    
    //下载银行卡列表&转账记录数据
    public static async downLoadBankData(data){
        let uri = this.groupUrl + '/exportCardInfo';
        return await ServerPriceApi.sendNoBase(uri, data);
    }

    //查看银行变更日志
    public static async showBankLog(data){
        let uri = this.groupUrl + '/cardChangeLog';
        return await ServerPriceApi.getNoBase(uri, data);
    }

    //查询银行转账记录
    public static async getBankTransferList(data){
        let uri = this.groupUrl + '/cardChargePage';
        return await ServerPriceApi.sendNoBase(uri, data);
    }

    //转账
    public static async bankTransfer(data){
        let uri = this.groupUrl + '/retryCardCharge';
        return await ServerPriceApi.getNoBase(uri, data);
    }

     //删除银行转账记录
     public static async deleteBankTransferInfo(data){
        let uri = this.groupUrl + '/deleteCardCharge';
        return await ServerPriceApi.getNoBase(uri, data);
    }
}


